import { Injectable } from '@angular/core';
import { NavController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  constructor(private navCtrl: NavController) {}

  showErrorScreen(queryParams?: any): void {
    this.navCtrl.navigateForward('/error', {
      queryParams
    });
  }
}